import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

class adminService {
  searchAdminList(user , search) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/sub-admin-name?search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    createAdmin(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/create/user-admin",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  
    getAdminProfile(user , page, search, ) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/view-sub-admins/?page=${page}&search=${search}&pageSize=${12}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    updateAdminPermission(id, data, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/admin/edit-subadmin-roles/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    editsubadminprofile(id, data, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/admin/subAdmin-profile-edit/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  
  resetPassword(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/admin/reset-password",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  allUserTransactionReport(user, payload, page, pageLimit) {
  return axios({
    method: "get",
    url: `${API_HOST}/api/transaction/get/${payload.userId}`,
    params: {
      page,
      pageSize: pageLimit,
      transactionType: payload.transactionType,
      startDate: payload.startDate,
      endDate: payload.endDate,
      subAdminId: payload.subAdminId,
      maxAmount: payload.maxAmount,
      minAmount: payload.minAmount,
      transactionId: payload.transactionId,
      introducerUserName: payload.introducerUserName,
      bankName: payload.bankName,
      websiteName: payload.websiteName,
    },
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  });
}

}


export default new adminService();